module.exports = __webpack_public_path__ + "img/location.d0a3f94f.png";